@if ({ locations: locations$ | async }; as state) {
  <ui-kit-auto-suggest
    class="auto-suggest"
    [options]="locations$ | async"
    [showAutoSuggest]="state.locations ? state.locations.length > 1 : false"
    [maxVisibleOptions]="50"
    [minWidth]="432"
    [formControl]="control"
    [targetTemplate]="targetTemplate"
    [positions]="positions"
    [comparatorFn]="comparatorOptions"
    [filterOptionsFn]="filterOptions"
    (selected)="onSelected($event)"
    >
    <ng-template let-option="option" let-isSelected="isSelected" uiKitAutoSuggestOption>
      <div class="dropdown-option">
        <div class="option-title">{{ option.label }}</div>
        <div class="option-description">{{ option.description }}</div>
      </div>
      @if (isSelected) {
        <ui-kit-icon icon="check" color="success"></ui-kit-icon>
      }
    </ng-template>
    <ng-template uiKitAutoSuggestEndOfList>
      <app-logout-button></app-logout-button>
    </ng-template>
  </ui-kit-auto-suggest>
}

<ng-template #targetTemplate let-value="value">
  <ui-kit-icon class="trigger-icon" icon="user" size="small" color="custom"></ui-kit-icon>
  <span class="location-name" uiKitTextTooltip="{{ ((locations$ | async) ?? []).length > 1 ? 'Change account' : '' }}">{{ value }}</span>
</ng-template>
